
// Componente PermissionGate
const PermissionGate = ({ children, permissions  }) => {
    // Lê e normaliza as permissões armazenadas no sessionStorage.
    // O backend pode enviar formatos diferentes (objeto de flags, array de strings,
    // ou array de objetos { nome }). Aceitamos todos os formatos.
    let raw = null;
    try {
        raw = JSON.parse(sessionStorage.getItem("permissoes")) || null;
    } catch (e) {
        raw = null;
    }

    const userPermissionsSet = new Set();

    if (Array.isArray(raw)) {
        // Array de strings ou array de objetos
        raw.forEach(item => {
            if (!item) return;
            if (typeof item === 'string') userPermissionsSet.add(item.toUpperCase());
            else if (typeof item === 'object') {
                if (item.nome) userPermissionsSet.add(String(item.nome).toUpperCase());
                else if (item.name) userPermissionsSet.add(String(item.name).toUpperCase());
                else if (item.permission) userPermissionsSet.add(String(item.permission).toUpperCase());
            }
        });
    } else if (raw && typeof raw === 'object') {
        // Objeto de flags: { cadastrarUsuarios: true, ... }
        Object.keys(raw).forEach(k => {
            if (raw[k]) userPermissionsSet.add(k.toUpperCase());
        });
    }

    // Por segurança: também aceita quando session armazena diretamente um objeto de permissões
    const hasPermission = permissions.every(permission => userPermissionsSet.has(permission.toUpperCase()));

    return hasPermission ? children : null;
};

export default PermissionGate;